export default __webpack_public_path__ + "static/media/authentic-ed.fb12a081.svg";